var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typewriter"},_vm._l((_vm.textToType),function(line,index){return _c('div',{key:'line' + index,ref:"line",refInFor:true,class:'typewriter__line line--' + index,staticStyle:{"display":"none"}},_vm._l((line),function(word,index){return _c('span',{key:'word' + index,ref:"word",refInFor:true,class:'typewriter__word word--' + index},_vm._l((word),function(char,index){return _c('span',{key:'char' + index,ref:"char",refInFor:true,class:'typewriter__char char--' + index,staticStyle:{"opacity":"0"}},[_vm._v(_vm._s(char))])}),0)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Typewriter.vue?vue&type=template&id=1861a054&
// module id = null
// module chunks = 